import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import PasswordInput from "../components/PasswordInput";
import { Stethoscope } from "lucide-react";
import api from "../lib/api";
import { toast } from "sonner";

export default function DoctorLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const res = await api.post("/auth/doctor/login", { email, password });
      localStorage.setItem("mano_jwt", res.data.token);
      localStorage.setItem("mano_user", JSON.stringify(res.data.user));
      toast.success(`Welcome, ${res.data.user.name || "Doctor"}`);
      nav("/doctor");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <main className="mano-container-narrow py-12 w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10 text-primary mb-3">
            <Stethoscope size={22} />
          </div>
          <h1 className="font-display font-semibold text-2xl tracking-tight" data-testid="doctor-login-title">
            Doctor sign-in
          </h1>
          <p className="text-sm text-muted-foreground mt-1">
            Independent clinical review · separate from the platform review flow
          </p>
        </div>
        <Card className="mano-card">
          <CardContent className="p-6">
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label htmlFor="email">Email</Label>
                <Input id="email" type="email" required
                       value={email} onChange={(e) => setEmail(e.target.value)}
                       data-testid="doctor-login-email" />
              </div>
              <div>
                <Label htmlFor="password">Password</Label>
                <PasswordInput id="password" required
                       value={password} onChange={(e) => setPassword(e.target.value)}
                       data-testid="doctor-login-password" />
              </div>
              <Button type="submit" disabled={busy}
                      className="w-full rounded-full mano-lift"
                      data-testid="doctor-login-submit">
                {busy ? "Signing in…" : "Sign in"}
              </Button>
              <div className="text-center pt-1">
                <Link to="/forgot-password"
                      className="text-sm text-primary underline underline-offset-4"
                      data-testid="doctor-login-forgot-link">
                  Forgot password?
                </Link>
              </div>
            </form>
          </CardContent>
        </Card>
      </main>
    </div>
  );
}
